import { ChatLauncher } from './ChatLauncher';
import { ChatPanel } from './ChatPanel';

/**
 * Mounted once at the app root (outside the router).
 * Renders the floating launcher + the chat panel.
 * Conversation state lives in <ChatProvider> above this component.
 */
export function ChatWidget() {
  return (
    <>
      <ChatLauncher />
      <ChatPanel />
    </>
  );
}
